export default "__VITE_ASSET__Be3CBt17__"